import React from 'react'
import PropTypes from 'prop-types'

/** JSON-LD rendered in document body (not head) for crawlers. */
const CustomJsonLd = ({ id, data }) => (
  <script
    id={id}
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
)

export default CustomJsonLd

CustomJsonLd.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
}
